import React from 'react'
import { Link } from 'react-router-dom'
import ImageWithBasePath from '../../../../core/common/imageWithBasePath'
import { all_routes } from '../../../router/all_routes'

interface BannerProps {
    apiValues: any;
}



const Becomeinstructor: React.FC<BannerProps> = ({ apiValues }) => {

    const route = all_routes
    return (
        <>
            {/* Become An Instructor */}
            <div className="section relative aos p-12"

                style={{
                    backgroundImage: `url(assets/img/bg/bg-5.png), url(assets/img/bg/bg-6.png)`,
                    backgroundPosition: "left bottom, right bottom",
                    backgroundRepeat:"no-repeat",
                    backgroundSize: "300px, 300px",
                }}
            >
                {/* <ImageWithBasePath
                    src="assets/img/bg/bg-5.png"
                    alt=""
                    className=" absolute  bottom-0 left-0 max-h-[300px]"
                />
                <ImageWithBasePath
                    src="assets/img/bg/bg-6.png "
                    alt=""
                    className=" absolute  bottom-0 right-0  max-h-[300px]"
                /> */}
                <div className="container">
                    <div className="row row-gap-3">
                        {
                            (Array.isArray(apiValues) ? apiValues : []).map((item: any, index: number) => {
                                return (

                                    <div className="col-md-6 ">
                                        <div className="student-mentor d-flex flex-fill" style={{
                                            paddingTop: "20px"
                                        }}>
                                            <div className="row w-full">
                                                <div className="col-lg-8 col-md-12">
                                                    <div className="top-instructors">
                                                        <h4>

                                                            {item?.title}
                                                        </h4>
                                                        <p>
                                                            {item?.description}


                                                        </p>
                                                        <Link
                                                            to={index == 0 ? "/Contact" : "/unlock"}

                                                            className="btn btn-secondary btn-xl"
                                                        >
                                                            {item?.buttonText}

                                                        </Link>
                                                    </div>
                                                </div>
                                                <div className="col-lg-4 col-md-12 items-center">
                                                    <div
                                                        className="img-fluid d-none d-lg-flex"
                                                    // style={{
                                                    //     backgroundImage: `url(${item?.imageUrl})`,
                                                    //     backgroundSize: "100% 100%",
                                                    //     backgroundRepeat:"no-repeat",
                                                    //     width: "100%",
                                                    //     height: "100%"
                                                    // }}
                                                    >
                                                        <ImageWithBasePath
                                                            source={
                                                                item?.imageUrl
                                                            }
                                                            className="img-fluid d-none d-lg-flex"
                                                            // height={40}
                                                            // width={40}
                                                            alt="Img"
                                                            style={{
                                                                maxHeight: 200
                                                            }}
                                                        />
                                                    </div>

                                                    {/* <div className="d-flex "> */}
                                                    {/* <ImageWithBasePath
                                                            className="img-fluid d-none d-lg-flex"
                                                            alt="Img"
                                                            src="assets/img/feature/feature-15.svg"
                                                        /> */}

                                                    {/* <ImageWithBasePath
                                                            source={
                                                                item?.imageUrl
                                                            }
                                                            className="img-fluid d-none d-lg-flex "
                                                            // height={40}
                                                            // width={40}
                                                            alt="Img"
                                                        /> */}
                                                    {/* </div> */}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )
                            }) || []
                        }

                    </div>
                </div>
            </div>
        </>

    )
}

export default Becomeinstructor
